import React from 'react';
import { TouchableOpacity } from 'react-native';

import PropTypes from 'prop-types';

import { Icon } from '@vfgroup-oneplatform/foundation/Components';

const ToggleIcon = ({ isOn, iconOn, iconOff, onPress }) => {
  return (
    <TouchableOpacity onPress={onPress}>
      <Icon name={isOn ? iconOn : iconOff} type="image" />
    </TouchableOpacity>
  );
};

ToggleIcon.propTypes = {
  onPress: PropTypes.func,
  isOn: PropTypes.bool,
  iconOff: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({ uri: PropTypes.string.isRequired }),
  ]).isRequired,
  iconOn: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({ uri: PropTypes.string.isRequired }),
  ]).isRequired,
};

ToggleIcon.defaultProps = {
  onPress: undefined,
  isOn: false,
};

export default ToggleIcon;
